import { useHead, useI18n } from '#imports';

export function useCookiePolicy() {
    function cookieInit() {
        const [lang] = useI18n().locale.value.toUpperCase().split('-');

        useHead().patch({
            script: [
                {
                    'id': 'CookieConsent',
                    'src': 'https://policy.app.cookieinformation.com/uc.js',
                    'defer': true,
                    'data-gcm-enabled': false,
                    'data-culture': lang,
                },
            ],
        });
    }

    function cookieOpen() {
        if (window && window.TogglePage && window.CookieConsent && window.CookieConsent.show) {
            window.CookieConsent.show();
            window.TogglePage(this, 'coiPage-3'); // eslint-disable-line new-cap
        } else {
            console.error('Cookie information not loaded');
        }
    }

    return {
        cookieInit,
        cookieOpen,
    };
}
